import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { PhoneInput } from '@/components/ui/phone-input';
import type { BeneficiaryValue } from '@/lib/beneficiary';

export function BeneficiaryFields({
  value,
  onChange,
}: {
  value: BeneficiaryValue;
  onChange: (next: BeneficiaryValue) => void;
}) {
  const set = <K extends keyof BeneficiaryValue>(key: K, input: BeneficiaryValue[K]) =>
    onChange({ ...value, [key]: input });

  return (
    <div className="space-y-3">
      <Label className="text-sm font-medium">Enter the lead details</Label>
      <div className="flex gap-2">
        <Button
          type="button"
          size="sm"
          variant={value.beneficiary === 'self' ? 'default' : 'outline'}
          onClick={() => set('beneficiary', 'self')}
        >
          Myself
        </Button>
        <Button
          type="button"
          size="sm"
          variant={value.beneficiary === 'other' ? 'default' : 'outline'}
          onClick={() => set('beneficiary', 'other')}
        >
          Someone else
        </Button>
      </div>

      {value.beneficiary === 'other' ? (
        <div className="space-y-3 rounded-xl border bg-muted/20 p-4">
          <div className="space-y-1">
            <Label htmlFor="beneficiary-name">Name</Label>
            <Input
              id="beneficiary-name"
              placeholder="Their full name"
              value={value.name}
              onChange={(e) => set('name', e.target.value)}
              maxLength={100}
            />
          </div>
          <div className="space-y-1">
            <Label>Phone</Label>
            <PhoneInput
              value={value.phone || undefined}
              onChange={(v) => set('phone', v ?? '')}
              placeholder="Enter phone number"
              defaultCountry="IN"
            />
          </div>
          <div className="space-y-1">
            <Label htmlFor="beneficiary-email">Email</Label>
            <Input
              id="beneficiary-email"
              type="email"
              placeholder="name@example.com"
              value={value.email}
              onChange={(e) => set('email', e.target.value)}
            />
          </div>
          <div className="space-y-1">
            <Label htmlFor="beneficiary-relation">Relation (optional)</Label>
            <Input
              id="beneficiary-relation"
              placeholder="e.g. brother, client, friend"
              value={value.relation}
              onChange={(e) => set('relation', e.target.value)}
              maxLength={100}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
